import { getBorderStyle } from "theme/helpers";
import { TStyles } from "utils/Styles";

const styles: TStyles = {
  defaultSelect: {
    minWidth: 200,

    ".MuiSelect-select.Mui-disabled ~ .MuiOutlinedInput-notchedOutline": {
      border: getBorderStyle("1px", "dashed", "custom.inputBorder"),
    },
  },

  unselect: { fontStyle: "italic" },
};

export default styles;
